import { useEventListener } from '../../../hooks/useEventListener';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { useHistory } from 'react-router-dom';
import CodeInput from '../CodeInput';
import React, { useCallback, useEffect, useState } from 'react';

export default function HomeCodeInput() {
    const history = useHistory();
    const [error, setError] = useState(false);
    const [code, setCode] = useState('');
    const [recaptchaToken, setRecaptchaToken] = useState<string | null>(null);

    const { executeRecaptcha } = useGoogleReCaptcha();

    const handleReCaptchaVerify = useCallback(async () => {
        if (!executeRecaptcha) {
            console.log('Execute recaptcha not yet available');
            return;
        }

        const token = await executeRecaptcha('code');
        setRecaptchaToken(token);
    }, [executeRecaptcha]);

    useEffect(() => {
        handleReCaptchaVerify();
    }, [handleReCaptchaVerify]);

    const validateCode = async () => {
        await handleReCaptchaVerify();
        if (recaptchaToken) {
            const re = new RegExp('^[a-zA-Z0-9]{10}$');
            if (re.test(code)) {
                history.push({
                    pathname: '/game-select',
                    state: { gameCode: code },
                });
            } else {
                setError(true);
            }
        }
    };

    const onCodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setCode(e.target.value.toUpperCase());
        setError(false);
    };

    function enterHandler({ key }: KeyboardEvent) {
        if ('Enter' === String(key)) {
            validateCode();
        }
    }

    useEventListener('keydown', enterHandler);

    return (
        <CodeInput
            errorMessage="Špatný kód, prosím zadejte znovu, kód má obsahovat 10 znaků"
            onClick={validateCode}
            onChange={onCodeChange}
            code={code}
            error={error}
        />
    );
}
